import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'

import { VerificationComponent } from './verification/verification.component'

@NgModule({
  declarations: [VerificationComponent],
  exports: [VerificationComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeAlertModule,
    SeFeButtonModule,
  ],
})
export class SeHouseholdSetupFeatureVerificationModule {}
